module.exports = "../images/timberlane-lodge-logo.png?v=9814333";